import { render, staticRenderFns } from "./AMCViewer.vue?vue&type=template&id=4d0e279e&scoped=true"
import script from "./AMCViewer.vue?vue&type=script&lang=js"
export * from "./AMCViewer.vue?vue&type=script&lang=js"
import style0 from "./AMCViewer.vue?vue&type=style&index=0&id=4d0e279e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0e279e",
  null
  
)

export default component.exports